
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { InputBorderType_Enum } from '../../enums/InputBorderType_Enum'
import { InputType_Enum } from '../../enums/InputType_Enum'
import { TooltipPosition_Enum } from '../../enums/TooltipPosition_Enum'
import CFInput from './CFInput'

	@Component({
	  name: 'InputNumeric'
	})
export default class InputNumeric extends Vue implements CFInput {
		@Prop() id!: string;
		@Prop({ default: '' }) name!: string;
		@Prop({ default: '' }) label!: string;
		@Prop({ default: 'Required' }) errorText!: string;
		@Prop() value!: string;
		@Prop({ default: true }) required!: boolean;
		@Prop({ default: 0 }) decimalPlaces!: 0 | 1 | 2;
		@Prop({ default: undefined }) min!: number;
		@Prop({ default: undefined }) max!: number;
		@Prop({ default: '' }) placeholder!: string;
		@Prop({ default: InputBorderType_Enum.underlined }) borderType!: InputBorderType_Enum;
		@Prop({ default: InputType_Enum.text }) type!: InputType_Enum;
		@Prop({ default: '' }) tooltipText!: string;
		@Prop({ default: TooltipPosition_Enum.left }) tooltipPosition!: TooltipPosition_Enum;
		@Prop({ default: 'under' }) errorPosition!: string;

		val: string | null = null;

		valid = true;

		placeholderTemp = '';

		@Watch('value', { immediate: true })
		set () {
		  this.val = this.value
		}

		@Watch('val', { immediate: true, deep: true })
		update () {
		  this.valid = true
		  this.$emit('input', this.val)
		}

		@Watch('placeholder', { immediate: true })
		changePlaceholder () {
		  this.placeholderTemp = this.placeholder
		}

		mounted () {
		  if (this.val) {
		    this.val = Number(this.val).toFixed(this.decimalPlaces)
		  }
		}

		validate () {
		  if ((!this.val || this.val === null) && !this.required) {
		    this.valid = true
		    return true
		  }

		  if ((!this.val || this.val === null) && this.required) {
		    this.valid = false
		    return false
		  }

		  const parsed = Number(this.val)

		  if (!isNaN(parsed) && parsed >= this.min) {
		    this.valid = true
		    return true
		  }

		  this.valid = false
		  return false
		}

		onBlur (evt: FocusEvent) {
		  if (this.min !== null && (evt.target as any).valueAsNumber < this.min) {
		    this.val = this.min.toString()
		  } else if (this.max !== null && (evt.target as any).valueAsNumber > this.max) {
		    this.val = this.max.toString()
		  }

		  if (this.val) {
		    this.val = Number(this.val).toFixed(this.decimalPlaces)
		  }

		  this.$emit('blur', this.val)
 		}

		focus () {
		  (this.$refs[this.id] as HTMLInputElement).focus()
		}

		get cssClass () {
		  return this.valid ? '' : 'error'
		}

		get step () {
		  if (this.decimalPlaces === 0) {
		    return 1
		  } else if (this.decimalPlaces === 1) {
		    return 0.1
		  }
		  return 0.01
		}

		get prefixSlot () {
		  return this.$slots.prefix
		}
}
